var electronicInsuranceSearch = function (device_type, device_brand, device_model, device_price) {
    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('electronic-field-error');
            setTimeout(function () {
                $target.removeClass('electronic-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    if (device_type.val() == -1 || device_type.find("option:selected").text() == "") {
        return showFieldError(device_type, 'لطفاً نوع دستگاه را انتخاب کنید.');
    }
    if (device_brand.val() == '') {
        return showFieldError(device_brand, 'لطفاً برند دستگاه را وارد کنید.');
    }
    if (device_model.val() == '') {
        return showFieldError(device_model, 'لطفاً مدل دستگاه را وارد کنید.');
    }
    if (device_price.val() == '') {
        return showFieldError(device_price, 'لطفاً قیمت دستگاه را وارد کنید.');
    }

    var url_param = '';
    var devicetype = device_type.val();
    var devicebrand = device_brand.val();
    var devicemodel = device_model.val();
    var deviceprice = device_price.val();

    url_param += '?deviceType=' + devicetype;
    url_param += '&deviceBrand=' + devicebrand;
    url_param += '&deviceModel=' + devicemodel;
    url_param += '&devicePrice=' + deviceprice;

    window.location = electronicInsuranceSearchUrl + '/' + url_param;
}
$(document).ready(function () {
    $('.electronic_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var device_type = $('#device_type_select');
        var device_brand = $('#device_brand_input');
        var device_model = $('#device_model_input');
        var device_price = $('#device_price_input');

        electronicInsuranceSearch(device_type, device_brand, device_model, device_price);
        return false;
    });
});

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
